// import React from "react";

// // javascript plugin used to create scrollbars on windows
// import PerfectScrollbar from "perfect-scrollbar";
// import { Outlet, Route, Routes } from "react-router-dom";

// import AdminNavbar from "components/Navbars/AdminNavbar.jsx";
// import Footer from "components/Footer/Footer.jsx";

// //import Sidebar from "components/Sidebar/Sidebar.jsx";
//  import Sidebar from "components/Sidebar/SidebarNew.jsx";

// import PortalNavbar from "components/Navbars/PortalNavbar.jsx";
// import PortalFooter from "components/Footer/PortalFooter.jsx";
// import PortalSidebar from "components/Sidebar/PortalSidebar.jsx";
// import { store } from 'store/index';
// import routes from "routes.js";

// import SidebarClose from "components/Sidebar/SidebarClose.jsx";

// var ps;

// class Admin extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       backgroundColor: "black",
//       activeColor: "info",
//       sidebarMini: false
//     };
//   }
//   componentDidMount() {
//     if (navigator.platform.indexOf("Win") > -1) {
//       document.documentElement.className += " perfect-scrollbar-on";
//       document.documentElement.classList.remove("perfect-scrollbar-off");
//       // ps = new PerfectScrollbar(this.refs.mainPanel);
//     }
//   }
//   componentWillUnmount() {
//     if (navigator.platform.indexOf("Win") > -1) {
//       // ps.destroy();
//       document.documentElement.className += " perfect-scrollbar-off";
//       document.documentElement.classList.remove("perfect-scrollbar-on");
//     }
//   }
//   componentDidUpdate(e) {
//     if (e.history.action === "PUSH") {
//       document.documentElement.scrollTop = 0;
//       document.scrollingElement.scrollTop = 0;
//       // this.refs.mainPanel.scrollTop = 0;
//     }
//   }
//   getRoutes = routes => {
//     return routes.map((prop, key) => {
//       if (prop.collapse) {
//         return this.getRoutes(prop.views);
//       }
//       if (prop.layout === "/admin") {
//         const Component = prop.component;
//         return (
//           <Route
//           path={prop.layout + prop.path}
//           element={<Component />}
//           key={key}
//           />
//         );
//       } else {
//         return null;
//       }
//     });
//   };
//   handleActiveClick = color => {
//     this.setState({ activeColor: color });
//   };
//   handleBgClick = color => {
//     this.setState({ backgroundColor: color });
//   };
//   handleMiniClick = () => {
//     if (document.body.classList.contains("sidebar-mini")) {
//       this.setState({ sidebarMini: false });
//     } else {
//       this.setState({ sidebarMini: true });
//     }
//     document.body.classList.toggle("sidebar-mini");
//   };
//   render() {
//  const { location } = this.props;
//     console.log("inside admin layout");

//     return (
//       <React.Fragment>
//         {/*<SidebarClose />*/}
//         {!store.getState().is_portal && store.getState().is_main && 
//           <>
//             <div className="portal container-fluid p-0">
//               <div className="siteWrap">
//                 <Sidebar
//                   {...this.props}
//                   routes={routes}
//                   bgColor={this.state.backgroundColor}
//                   activeColor={this.state.activeColor}
//                 />
//                 <Outlet/>
//                 {/* <Routes>{this.getRoutes(routes)}</Routes> */}
//               </div>
//             </div>
//             {location.pathname.indexOf("full-screen-map") !== -1 ? null : (
//               <Footer fluid />
//             )}
//           </>
//         }
//         {(store.getState().is_portal || !store.getState().is_main) && 
//           <div className="wrapper">
//             <PortalSidebar
//               {...this.props}
//               routes={routes}
//               bgColor={this.state.backgroundColor}
//               activeColor={this.state.activeColor}
//             />
//             {/*<div className="main-panel" ref="mainPanel">*/}
//             <div>
//               <PortalNavbar {...this.props} handleMiniClick={this.handleMiniClick} />
//              <Outlet/>
//               {/* <Routes>{this.getRoutes(routes)}</Routes> */}
//               {location.pathname.indexOf("full-screen-map") !== -1 ? null : (
//                 <PortalFooter fluid />
//               )}
//             </div>
//           </div>
//         }
//       </React.Fragment>
//     );
//   }
// }

// export default Admin;

import React, { useState, useEffect, useRef } from "react";
import { Outlet, useLocation, Routes, Route, Navigate } from "react-router-dom";

import Footer from "components/Footer/Footer.jsx";
import Sidebar from "components/Sidebar/SidebarNew.jsx";

import PortalNavbar from "components/Navbars/PortalNavbar.jsx";
import PortalFooter from "components/Footer/PortalFooter.jsx";
import PortalSidebar from "components/Sidebar/PortalSidebar.jsx";

import { useSelector } from 'react-redux';
import { useSidebar } from "context/SidebarContext";
import routes from "routes";
import RegionBlocker from "components/RegionBlocker";
import InvalidRegionAccess from "page/InvalidRegionAccess";
// import MobileAppBanner from "components/Dashboard/New/MobileAppBanner";
// import AdminNavbar from "components/Navbars/AdminNavbar.jsx";
// import { store } from 'store/index';
// import routes from "../routes-minimal.js";
// import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import {
  isTestRoute,
  isThemeRoute,
  stopAllMicrophoneStreams,
  revokeMicrophonePermission,
  ensureLightTheme,
  enforceFullscreenByRoute
} from 'util/microphonePermissionManager';
import ChatBot from "components/ChatBot/ChatBot";
import { shouldHideChatBot } from "components/ChatBot/chatBotRoutes";

const Admin = (props) => {
  const [backgroundColor, setBackgroundColor] = useState("black");
  const [activeColor, setActiveColor] = useState("info");
  const [sidebarMini, setSidebarMini] = useState(false);

  const { isOpen } = useSidebar();
  const mainPanelRef = useRef(null);
  const location = useLocation();

  // Use Redux hooks for proper state subscription
  const isPortal = useSelector(state => state.is_portal);
  const isMain = useSelector(state => state.is_main);

  const layoutConfig = (() => {
  const path = location.pathname;

  const isTestMode = shouldHideChatBot(path);

  return {
    hideSidebar: path.includes("/fulltest/") || path.includes("/sub/success"),
    fullWidth: isTestMode || path.includes("/sub/success"),
    hideFooter:
      path.includes("full-screen-map") || isTestMode
  };
})();

  // Remove PerfectScrollbar: rely on native scrolling

  // Scroll to top on route change
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainPanelRef.current) {
      mainPanelRef.current.scrollTop = 0;
    }
  }, [location]);

  // Handle #adminScrollUp indicator for .main-panel
  // (separate id from the public-page jQuery scrollUp plugin to avoid duplicate ids)
  useEffect(() => {
    const mainPanel = mainPanelRef.current;
    if (!mainPanel) return;

    const handleScroll = () => {
      const scrollUp = document.getElementById("adminScrollUp");
      if (scrollUp) {
        if (mainPanel.scrollTop > 300) {
          scrollUp.style.display = "block";
        } else {
          scrollUp.style.display = "none";
        }
      }
    };

    const handleScrollToTop = (e) => {
      const scrollUp = document.getElementById("adminScrollUp");
      if (scrollUp && (e.target === scrollUp || scrollUp.contains(e.target))) {
        e.preventDefault();
        e.stopPropagation();
        mainPanel.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    };

    mainPanel.addEventListener("scroll", handleScroll);
    document.addEventListener("click", handleScrollToTop, true);

    return () => {
      mainPanel.removeEventListener("scroll", handleScroll);
      document.removeEventListener("click", handleScrollToTop, true);
    };
  }, []);


  // Manage microphone permissions based on route
  useEffect(() => {
    const currentPath = location.pathname;
    
    const cleanup = async () => {
      // console.log(isTestRoute(currentPath));
      
      if (!isTestRoute(currentPath)) {
        await stopAllMicrophoneStreams(); // ✅ Await cleanup
      }
    };
    
    cleanup();
    
    if(!isThemeRoute(currentPath)){
      ensureLightTheme()
    }
    
    enforceFullscreenByRoute(currentPath);

    return () => {
      revokeMicrophonePermission();
    };
  }, [location.pathname]);

  const handleActiveClick = (color) => {
    setActiveColor(color);
  };

  const handleBgClick = (color) => {
    setBackgroundColor(color);
  };

  const handleMiniClick = () => {
    setSidebarMini(prev => !prev);
    document.body.classList.toggle("sidebar-mini");
  };

  // ✅ Function to get page title based on current path
  const getPageTitle = () => {
    let title = "";
    routes.forEach((route) => {
      if (route.collapse && route.views) {
        route.views.forEach((view) => {
          if (location.pathname.includes(view.path)) {
            title = view.name || "";
          }
        });
      } else if (location.pathname.includes(route.path)) {
        title = route.name || "";
      }
    });
    return title;
  };

  const pageTitle = getPageTitle();
  
  // Check if user is authenticated
  const token = useSelector(state => state.token);
  
  if (!token) {
    return <Navigate to="/auth/login" replace />;
  }
  
  return (
    <React.Fragment>
      <RegionBlocker />
      <InvalidRegionAccess />
      {/* Admin Layout - when NOT portal and IS main */}
      {!isPortal && isMain && (
        <div className="portal container-fluid p-0">
          <div className="siteWrap">
            {!layoutConfig.hideSidebar && (
              <Sidebar
                {...props}
                routes={routes}
                bgColor={backgroundColor}
                activeColor={activeColor}
              />
            )}
            <div className="main-panel" ref={mainPanelRef} style={{
               width: layoutConfig.fullWidth ? "100vw" : (isOpen ? "calc(100% - 260px)" : "calc(100% - 75px)"), overflowX: "hidden" , overflowY: "auto" 
            }}>
              {/* <AdminNavbar {...props} /> */}
              {/* <DashboardHeader title={pageTitle || "Untitled"} /> */}
              <Routes>
                {routes?.map((prop, key) => {
                  if (prop?.collapse) {
                    return prop?.views.map((view, viewKey) => {
                      if (view.layout === "/admin") {
                        const Component = view.component;
                        return (
                          <Route
                            key={`${key}-${viewKey}`}
                            path={view?.path}
                            element={<Component />}
                          />
                        );
                      }
                      return null;
                    });
                  }
                  if (prop.layout === "/admin") {
                    const Component = prop.component;
                    return (
                      <Route
                        key={key}
                        path={prop.path}
                        element={<Component />}
                      />
                    );
                  }
                  return null;
                })}
              </Routes>
              {!layoutConfig.hideFooter && (
                  <Footer fluid />
                )}
            </div>
          </div>
          {/* Visual styling (size/color/position/hover + responsive) is shared with
              the public-page #scrollUp button via /css/style.css so both match.
              Only the JS-toggled display state stays inline. */}
          <div
            id="adminScrollUp"
            title="Scroll to top"
            // style={{ display: "none" }}
          >
            <i className="fa fa-level-up" />
          </div>
        </div>
      )}

      {/* Portal Layout - when IS portal OR NOT main */}
      {(isPortal) && token && (
        <div className="wrapper">
          <PortalSidebar
            {...props}
            routes={routes}
            bgColor={backgroundColor}
            activeColor={activeColor}
          />
          <div className="main-panel" ref={mainPanelRef}>
            <PortalNavbar {...props} handleMiniClick={handleMiniClick} />
            <Routes>
              {routes.map((prop, key) => {
                if (prop.collapse) {
                  return prop.views.map((view, viewKey) => {
                    if (view.layout === "/admin") {
                      const Component = view.component;
                      return (
                        <Route
                          key={`${key}-${viewKey}`}
                          path={view.path}
                          element={<Component />}
                        />
                      );
                    }
                    return null;
                  });
                }
                if (prop.layout === "/admin") {
                  const Component = prop.component;
                  return (
                    <Route
                      key={key}
                      path={prop.path}
                      element={<Component />}
                    />
                  );
                }
                return null;
              })}
            </Routes>
            {!location.pathname.includes("full-screen-map") && (
              <PortalFooter fluid />
            )}
          </div>
        </div>
      )}
      {(!shouldHideChatBot(location.pathname) && import.meta.env.VITE_SHOW_NOVA === "true") && <ChatBot />}
    </React.Fragment>
  );
};

export default Admin;

// import React from "react";
// import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
// import PerfectScrollbar from "perfect-scrollbar";

// import AdminNavbar from "components/Navbars/AdminNavbar.jsx";
// import Footer from "components/Footer/Footer.jsx";
// import Sidebar from "components/Sidebar/SidebarNew.jsx";

// import PortalNavbar from "components/Navbars/PortalNavbar.jsx";
// import PortalFooter from "components/Footer/PortalFooter.jsx";
// import PortalSidebar from "components/Sidebar/PortalSidebar.jsx";
// import { store } from 'store/index';
// import routes from "routes.js";

// var ps;

// class Admin extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       backgroundColor: "black",
//       activeColor: "info",
//       sidebarMini: false
//     };
//   }

//   componentDidMount() {
//     if (navigator.platform.indexOf("Win") > -1) {
//       document.documentElement.className += " perfect-scrollbar-on";
//       document.documentElement.classList.remove("perfect-scrollbar-off");
//     }
//   }

//   componentWillUnmount() {
//     if (navigator.platform.indexOf("Win") > -1) {
//       document.documentElement.className += " perfect-scrollbar-off";
//       document.documentElement.classList.remove("perfect-scrollbar-on");
//     }
//   }

//   componentDidUpdate(e) {
//     if (e.history?.action === "PUSH") {
//       document.documentElement.scrollTop = 0;
//       document.scrollingElement.scrollTop = 0;
//     }
//   }

//   handleActiveClick = color => {
//     this.setState({ activeColor: color });
//   };

//   handleBgClick = color => {
//     this.setState({ backgroundColor: color });
//   };

//   handleMiniClick = () => {
//     this.setState(prev => ({ sidebarMini: !prev.sidebarMini }));
//     document.body.classList.toggle("sidebar-mini");
//   };

//   render() {
//     const { location } = this.props; // ✅ injected via HOC
//     console.log("inside  admin");

//     return (
//       <React.Fragment>
//         {!store.getState().is_portal && store.getState().is_main &&
//           <>
//             <div className="portal container-fluid p-0">
//               <div className="siteWrap">
//                 <Sidebar
//                   {...this.props}
//                   routes={routes}
//                   bgColor={this.state.backgroundColor}
//                   activeColor={this.state.activeColor}
//                 />
//                 <Outlet/>
//               </div>
//             </div>
//             {location?.pathname?.includes("full-screen-map") ? null : (
//               <Footer fluid />
//             )}
//           </>
//         }
//         {(store.getState().is_portal || !store.getState().is_main) &&
//           <div className="wrapper">
//             <PortalSidebar
//               {...this.props}
//               routes={routes}
//               bgColor={this.state.backgroundColor}
//               activeColor={this.state.activeColor}
//             />
//             <div>
//               <PortalNavbar {...this.props} handleMiniClick={this.handleMiniClick} />
//               <Outlet/>
//               {location?.pathname?.includes("full-screen-map") ? null : (
//                 <PortalFooter fluid />
//               )}
//             </div>
//           </div>
//         }
//       </React.Fragment>
//     );
//   }
// }

// // HOC to inject router props into class component
// export function withRouter(Component) {
//   return props => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const params = useParams();
//     return <Component {...props} location={location} navigate={navigate} params={params} />;
//   };
// }

// export default withRouter(Admin);
